// extracted by mini-css-extract-plugin
export default {"title":"YearPlan_title__TgW9T","subtitles":"YearPlan_subtitles__csn88","optionButtons":"YearPlan_optionButtons__GDxPD","addPlanButton":"YearPlan_addPlanButton__wYfmm"};